let layerId = 0;
export function getNextLayerId() {
    return '' + layerId++;
}
